import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import {
  Avatar,
  C,
  Utils,
  openModalForm,
  selectServicesKapp,
} from '@kineticdata/bundle-common';
import { Link } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { logout, I18n } from '@kineticdata/react';

const ProfileDropdownComponent = ({
  profile,
  eauthUrl,
  openFeedbackForm,
  openHelpForm,
  isOpen,
  toggle,
  push,
}) => (
  <Dropdown isOpen={isOpen} toggle={toggle} className="profile-dropdown">
    <DropdownToggle nav role="button" aria-label="Profile Menu">
      <Avatar size={36} color="#4f5051" user={profile} previewable={false} />
    </DropdownToggle>
    <DropdownMenu right className="profile-menu">
      <div className="dropdown-menu__header">
        <div>
          <strong>{profile.displayName}</strong>
        </div>
        <small className="text-muted">{profile.email}</small>
      </div>
      <hr />
      <div className="dropdown-menu__links pb-2">
        <Link
          to="/profile"
          className="dropdown-item"
          onClick={toggle}
          role="menuitem"
        >
          <I18n>Profile</I18n>
        </Link>
        {eauthUrl && (
          <a
            href={eauthUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
            onClick={toggle}
            role="menuitem"
          >
            <I18n>Manage eAuth Access</I18n>
          </a>
        )}
        <button
          onClick={openHelpForm}
          className="dropdown-item"
          role="menuitem"
        >
          <I18n>Get Help</I18n>
        </button>
        <button
          onClick={openFeedbackForm}
          className="dropdown-item"
          role="menuitem"
        >
          <I18n>Give Feedback</I18n>
        </button>
        <hr />
        <button
          onClick={() => logout(() => push('/logout'))}
          className="dropdown-item"
          role="menuitem"
        >
          <I18n>Logout</I18n>
        </button>
      </div>
    </DropdownMenu>
  </Dropdown>
);

const mapStateToProps = state => ({
  profile: state.app.profile,
  servicesKapp: selectServicesKapp(state),
  eauthUrl: Utils.getAttributeValue(state.app.space, C.SPACE_ATTR_EAUTH_URL),
});

const mapDispatchToProps = { push };

export const ProfileDropdown = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isOpen', 'setIsOpen', false),
  withHandlers({
    openHelpForm: props => () => {
      props.setIsOpen(false);
      openModalForm({
        ...C.HELP_FORM_CONFIG,
        kappSlug: props.servicesKapp && props.servicesKapp.slug,
      });
    },
    openFeedbackForm: props => () => {
      props.setIsOpen(false);
      openModalForm({
        ...C.FEEDBACK_FORM_CONFIG,
        kappSlug: props.servicesKapp && props.servicesKapp.slug,
      });
    },
    toggle: props => () => props.setIsOpen(open => !open),
  }),
)(ProfileDropdownComponent);
